import { PureComponent } from "react";
import classnames from "classnames";

import { componentStyles } from "./manage-option-component.scss";

export default class ManageOptionComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onSelectItem = this.onSelectItem.bind(this);
  }

  onSelectItem() {
    const { optionText, onSelect } = this.props;
    onSelect(optionText);
  }

  render() {
    const { optionText, isSelected } = this.props;
    const backgroundColor = isSelected ? "rgba(163, 88, 223, 0.1)" : "none";

    return (
      <div
        className={classnames("manage-option-box", { selected: isSelected })}
        style={{ background: backgroundColor }}
        onClick={this.onSelectItem}
      >
        <div className="manage-option">{optionText}</div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
